import React from 'react';

const CreatorSkeleton: React.FC = () => {
  return (
    <div className="ui-card !rounded-[20px] p-4 flex flex-col gap-3">
      {/* Cover */}
      <div className="w-full aspect-[328/214] rounded-2xl ui-surface-2 animate-pulse" />

      {/* Info */}
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2.5">
            <div className="w-10 h-10 rounded-full ui-surface-2 animate-pulse shrink-0" />
            <div className="h-4 w-16 rounded ui-surface-2 animate-pulse" />
          </div>
          <div className="h-4 w-20 rounded ui-surface-2 animate-pulse" />
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <div className="h-4 w-28 rounded ui-surface-2 animate-pulse" />
            <div className="h-4 w-6 rounded ui-surface-2 animate-pulse" />
          </div>
          <div className="flex items-center justify-between">
            <div className="h-4 w-20 rounded ui-surface-2 animate-pulse" />
            <div className="h-4 w-6 rounded ui-surface-2 animate-pulse" />
          </div>
        </div>
      </div>

      {/* Button */}
      <div className="w-full h-10 rounded-full ui-surface-2 animate-pulse" />
    </div>
  );
};

export default CreatorSkeleton;
